import template from './this-object-on-other-websites.jade';
import thisObjectOnOtherWebsitesCtrl from './this-object-on-other-websites.controller';

export default () => {
  return {
    template,
    scope: {},
    bindToController: {},
    controller: thisObjectOnOtherWebsitesCtrl,
    controllerAs: 'thisObjectOnOtherWebsitesCtrl',
    replace: true,
  };
};
